import React from "react";
import { CarDetailState, ProductDetail } from "../../types";
import { useUser } from "src/business-types/grocery/components/UserContext";
import { colorOptions } from "src/shared/modules/profile/theme/themeConstants";

interface ServiceTableProps {
  products: ProductDetail[];
  startIndex?: number;
  categories: CarDetailState[];
}

const formatCurrency = (value: number | string): string => {
  const num = typeof value === "string" ? parseFloat(value) : value;
  return isNaN(num) ? "0.00" : num.toFixed(2);
};

const ServiceTable: React.FC<ServiceTableProps> = ({ categories, products, startIndex = 1 }) => {
  const { user } = useUser();

  const themeKey = user?.background_colour || "DodgerBlue";
  const bgClass = colorOptions[themeKey] || "bg-blue-500";
  // const fontClass = fontOptions[user?.font_family || "Sans-serif"];

  // Function to find category name by product category
  // const getCategoryName = (productCategory: string): string => {
  //   if (!productCategory) return "Uncategorized";

  //   const foundCategory = categories.find((cat) => cat.CategoryName.toLowerCase() === productCategory.toLowerCase());

  //   return foundCategory?.CategoryName || productCategory || "Uncategorized";
  // };

  return (
    <div className="w-full">
      <table className="order-table w-full">
        <thead className={bgClass}>
          <tr>
            <th className="order-table-header py-2 px-3 text-left text-sm">S.No</th>
            <th className="order-table-header py-2 px-3 text-left text-sm">Service</th>
            <th className="order-table-header py-2 px-3 text-right text-sm">Price</th>
          </tr>
        </thead>
        <tbody>
          {products.map((product, idx) => (
            <tr key={idx} className="order-table-row border-b border-gray-200 hover:bg-gray-50">
              <td className="order-table-cell py-2 px-3 text-sm">{startIndex + idx}</td>
              <td className="order-table-cell py-2 px-3 text-sm">{product.product}</td>
              <td className="order-table-cell py-2 px-3 text-right text-sm">{formatCurrency(product.price)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ServiceTable;
